import { type PropsWithChildren } from "react";
import { Outlet } from "react-router";
import { ConsentGate } from "../workspace/ConsentGate.tsx";
import { HomeRedirectBoundary } from "../workspace/HomeRedirectBoundary.tsx";
import { ProtectAccessBoundary } from "../workspace/ProtectAccessBoundary.tsx";
import { ProtectRegionGate } from "../workspace/ProtectRegionGate.tsx";
import { SubscriptionBoundary } from "../workspace/SubscriptionBoundary.tsx";

/**
 * Must render inside the page layout, not above it: a redirect renders nothing, and above the layout
 * that blanks the header and sidebar and remounts them on every nav click from a zero-state page.
 */
export function ModuleGates({ children = <Outlet /> }: PropsWithChildren) {
    return (
        <SubscriptionBoundary>
            <ProtectAccessBoundary>
                <ConsentGate>
                    <ProtectRegionGate>
                        <HomeRedirectBoundary>{children}</HomeRedirectBoundary>
                    </ProtectRegionGate>
                </ConsentGate>
            </ProtectAccessBoundary>
        </SubscriptionBoundary>
    );
}
